module.exports = __webpack_public_path__ + "img/n2.238512f3.jpeg";